import "./newsletterOptin.scss";

import React, { FunctionComponent, useCallback, useContext, useState } from "react";

import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext";
import { useCustomerInfo } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/services/magento/customer/hooks/useCustomerInfo";
import { useTranslation } from "react-i18next";
import { FeedbackContext } from "../../../contexts/feedback/feedbackContext";
import { Input } from "../../primitives";

export const NewsletterOptin: FunctionComponent = () => {
    const { t } = useTranslation("mainLayout");
    const [email, setEmail] = useState("");
    const { customerInfo } = useCustomerInfo();
    const { addAlert } = useContext(FeedbackContext);
    const config = {
        type: "default",
        action: {
            provider: "mailchimp",
            apiKey: "123",
            list: "",
        },
        heading: t("newsletter-optin"),
        placeholder: t("newsletter-placeholder"),
        submitText: ">",
    };

    const servicesContext = useContext(ServicesContext);
    const customerService = servicesContext?.magento.customerService;

    const subscribeEmail = useCallback(
        async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            await customerService.operations.subscribeEmailToNewsletter(email)
                .then(() =>
                    addAlert({
                        message: t("toastMessages:subscribe-newsletter-success", { email: email }),
                        status: "success",
                    })
                )
                .catch((error) => addAlert({ message: error, status: "error" }));
        },
        [addAlert, email, customerInfo, t]
    );

    return (
        <div className="footer-newsletterOptin">
            <div className="container">
                <form name="newsletter" onSubmit={subscribeEmail}>
                    <h4>{config.heading}</h4>
                    <div className="inputGroup">
                        <Input
                            type="email"
                            placeholder={config.placeholder ? config.placeholder : "Email"}
                            value={email}
                            onChange={(value: string) => setEmail(value)}
                            required
                        />
                        <Input
                            type="submit"
                            value={config.submitText ? config.submitText : "Submit"}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};
